import type { JobMatchingHighlightsV2Fragment } from '@xing-com/crate-jobs-graphql';

import { getMatchingHighlightsFlags } from './matching-highlights';

export type GetSimilarJobsArg = {
  matchingHighlights?: JobMatchingHighlightsV2Fragment | null;
  isExternalJobAd: boolean;
  isUrgentlyHiringJob?: boolean;
};

const EXTERNAL_JOB_AD_FLAG = 'external_job_ad';
const URGENTLY_HIRING_JOB_FLAG = 'job_urgently_hiring';

export const getSimilarJobFlags = ({
  matchingHighlights,
  isExternalJobAd,
  isUrgentlyHiringJob = false,
}: GetSimilarJobsArg): string | undefined => {
  const flags = [
    getMatchingHighlightsFlags(matchingHighlights),
    isExternalJobAd ? EXTERNAL_JOB_AD_FLAG : undefined,
    isUrgentlyHiringJob ? URGENTLY_HIRING_JOB_FLAG : undefined,
  ]
    .filter(Boolean)
    .join(',');

  return flags.length ? flags : undefined;
};
